import { getSessionToken } from '@shopify/app-bridge/utilities';

// The public Shopify API key (client_id). This is not a secret - it is visible
// in shopify.app.toml and in the embedded app URL. Prefer the build-time env
// var, fall back to the known client_id so builds without env config still work.
export const SHOPIFY_API_KEY =
  process.env.REACT_APP_SHOPIFY_API_KEY || '5c0c049b8058cc629b0de04ea24395d5';

// Set to "true" only for local development outside of the Shopify admin.
export const SKIP_APP_BRIDGE = process.env.REACT_APP_SKIP_APP_BRIDGE === 'true';

// App Bridge instance is created inside React (via <Provider>), but the axios
// interceptors live at module scope. We stash the instance here so requests can
// mint a fresh session token for every call.
let appInstance = null;

export const setAppBridgeInstance = (app) => {
  appInstance = app;
};

export const getAppBridgeInstance = () => appInstance;

// Returns a short-lived Shopify session token (signed JWT) or null when App
// Bridge is unavailable (e.g. local dev outside the admin).
export const fetchSessionToken = async () => {
  if (!appInstance) {
    return null;
  }
  try {
    return await getSessionToken(appInstance);
  } catch (error) {
    console.warn('⚠️  Failed to obtain Shopify session token', error);
    return null;
  }
};

// The `host` param is provided by Shopify when the app is embedded in the admin.
// It is required to initialize App Bridge. We persist it so client-side route
// changes (which drop the query string) don't lose it.
export const getHost = () => {
  const params = new URLSearchParams(window.location.search);
  let host = params.get('host');
  if (host) {
    try {
      sessionStorage.setItem('shopify_host', host);
    } catch (error) {
      /* sessionStorage may be unavailable in some embedded contexts */
    }
  } else {
    try {
      host = sessionStorage.getItem('shopify_host');
    } catch (error) {
      host = null;
    }
  }
  return host;
};
